/*
 * @Author: EdwardYoung
 * @Date: 2017-07-25 16:34:20
 * @Last Modified by: EdwardYoung
 * @Last Modified time: 2017-08-22 11:16:34
 */

import axios from 'api/axios.js'
import {createApiHeader} from './createApiHeader.js'

/**
 * @param {活动id} id
 * @return {活动信息}
 */
function getActivityInfById (id) {
  return new Promise((resolve, reject) => {
    window.yhsd.ready(function (sdk) {
      sdk.account.current(function (User) {
        createApiHeader(axios, User.res.customer)
        _getActivityInfById(id).then((res) => {
          resolve(res.data.data)
        }).catch((err) => {
          reject(err.response.data.message)
        })
      })
    })
  })
}

/**
 * 根据活动id拉取活动信息
 */
function _getActivityInfById (id) {
  const activityInfUrl = `/v1/front/campaigns/${id}`
  return axios({
    method: 'get',
    url: activityInfUrl
  })
}

export {getActivityInfById}



// WEBPACK FOOTER //
// ./src/api/getActivityInfById.js